/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermDto } from '../../models/term-dto';

export interface TermControllerFindAll$Params {
}

export function termControllerFindAll(http: HttpClient, rootUrl: string, params?: TermControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TermDto>>> {
  const rb = new RequestBuilder(rootUrl, termControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TermDto>>;
    })
  );
}

termControllerFindAll.PATH = '/api/term';
